import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Alert = Loadable(lazy(() => import('./Alert')));

const AlertRoutes = [
	{
		path: '/alert',
		element: <Alert />,
		auth: authRoles.admin,
	},
];

export default AlertRoutes;
